import {
  Box,
} from '@mui/material'

import Layout from 'lib/components/Layout'
import LegalDocument from 'lib/components/LegalDocument'

import { LICENSES } from './content'

const sectionStyles = {
  pt: 18,
  pb: 10,
}

function LicensesPage() {
  return (
    <Layout>
      <Box
        id="main"
        component="section"
        sx={sectionStyles}
      >
        <LegalDocument {...LICENSES} />
      </Box>
    </Layout>
  )
}

export default LicensesPage
